import {useMemo, useState} from "react";

type KeyboardNavigationType = {
    itemClassName: string;
    itemContainerClassSelector: string;
    skipClassName?: string;
    resetCallback?: any;
    selectedCallback?: any;
}

const useKeyboardNavigation = (props: KeyboardNavigationType) => {
    const [ optionsCycled, setOptionsCycled ] = useState<boolean>(false);

    const FocusPrevious = (el: any, isSingle: boolean) => {
        const prevEl = el.previousElementSibling;
        const prevInput = prevEl?.querySelector('input');
        const prevSiblingInput = prevEl?.previousElementSibling?.querySelector('input');

        const parentEl = el.parentElement;
        const parentInput = parentEl?.previousElementSibling?.querySelector('input');
        const parentSibling = parentEl?.previousElementSibling?.previousElementSibling;
        const parentSiblingInput = parentSibling?.querySelector('input');

        if(prevEl) {
            if(isSingle) {
                prevEl.focus()
            } else if(prevInput) {
                prevInput.focus();
            } else if (prevSiblingInput) {
                prevSiblingInput.focus()
            } else {
                parentInput?.focus();
            }
        } else if(parentEl) {
            if(parentInput) {
                parentInput.focus();
            } else if(parentSibling) {
                parentSiblingInput.focus();
            } else {
                parentEl?.previousElementSibling?.querySelector('input').focus();
            }
        }

    }

    const FocusNext = (e: any, el: any, isTabbed: boolean, isSingle: boolean) => {
        const nextEl = el.nextElementSibling;
        const nextInput = nextEl?.querySelector('input');
        const nextSiblingInput = nextEl?.nextElementSibling?.querySelector('input');

        const parentEl = el.parentElement;
        const parentInput = parentEl?.firstElementChild?.querySelector('input');
        const parentSibling = parentEl?.firstElementChild?.nextElementSibling;
        const parentSiblingInput = parentSibling?.querySelector('input');

        if(nextEl) {
            e.preventDefault();

            if(isSingle) {
                nextEl.focus();
            } else if(nextInput) {
                nextInput.focus();
            } else if (nextSiblingInput) {
                nextSiblingInput.focus();
            } else {
                parentEl?.previousElementSibling?.querySelector('input').nextElementSibling?.focus();
            }

        } else if(!isTabbed && parentEl) {
            e.preventDefault();

            if(parentInput) {
                parentInput.focus();
            } else if(parentSibling) {
                isSingle ? parentEl?.firstElementChild?.focus() : parentSiblingInput.focus();
            } else {
                parentEl.firstElementChild?.querySelector('input').nextElementSibling?.focus();
            }

        } else {
            setOptionsCycled(!optionsCycled);
        }
    }

    const HandleKeyboardElementNavigation = (e: any) => {
        const fromInput = e.target.matches('input[type=text]');
        const menuItem = e.target.classList.contains(props.itemClassName);
        const refElement = menuItem ? e.target : e.target.parentElement.parentElement;

        if(fromInput) {
            switch(e.code) {
                case 'ArrowDown':
                    HandleInputNavigation(e);
                    break;
                case 'Escape':
                    HandleInputEscape(e);
                    break;
            }
        } else if (e.shiftKey && e.code === 'Tab') {
            e.preventDefault();
            FocusPrevious(refElement, menuItem);
        } else {
            switch(e.code) {
                case 'ArrowUp':
                    e.preventDefault();
                    FocusPrevious(refElement, menuItem);
                    break;
                case 'Tab':
                case 'ArrowDown':
                    FocusNext(e, refElement, e.code === 'Tab', menuItem);
                    break;
                case 'Escape':
                    e.preventDefault();
                    refElement.parentElement.nextElementSibling?.focus();
                    setOptionsCycled(true);
                    break;
                case 'Space':
                case 'ShiftLeft':
                case 'ShiftRight':
                    break;
                case 'Enter':
                    if(props.selectedCallback) {
                        props.selectedCallback(e);
                    }
                    break;
                default:
                    refElement.parentElement?.previousElementSibling?.querySelector('input').focus();
            }
        }

        document.querySelector('input:focus')?.scrollIntoView({ block: 'center' });
    }

    const HandleElementTransitionNavigation = (e: any) => {
        if(e.code) {
            HandleKeyboardElementNavigation(e);
        }
    }

    const HandleInputNavigation = (e: any) => {
        let firstChild : HTMLDivElement = document.querySelector(props.itemContainerClassSelector)?.firstElementChild as HTMLDivElement;

        if(firstChild && props.skipClassName && firstChild.classList.contains(props.skipClassName)) {
            firstChild = firstChild.nextElementSibling as HTMLDivElement;
        }

        if(firstChild) {
            e.preventDefault();

            const nextInput = firstChild.querySelector('input');
            const nextSiblingInput = firstChild.nextElementSibling?.querySelector('input');

            if(nextInput) {
                nextInput.focus();
            } else if(nextSiblingInput) {
                nextSiblingInput.focus();
            } else {
                firstChild.focus();
            }
        }
    }

    const HandleInputEscape = (e: any) => {
         if(e.code && e.code === 'Escape') {
            e.target.value = '';
            if(props.resetCallback) {
                props.resetCallback();
            }
        }
    }

    const ResetKeyboardTracking = () => {
        setOptionsCycled(false);
    };

    return useMemo(() => ({
        optionsCycled,
        ResetKeyboardTracking,
        HandleKeyboardElementNavigation,
        HandleElementTransitionNavigation,
        HandleInputEscape
    }),[optionsCycled]);
}

export default useKeyboardNavigation
